// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"626":"c53182fc","712":"eba93993","828":"2d2b10b1"}[chunkId] + ".chunk.css";
};